module.exports = __webpack_public_path__ + "img/vscode_logo.fee77d98.svg";